import React from 'react';
import Flex from '../containers/Flex';
import AutoFlex from '../containers/AutoFlex';
import AsText from '../AsText';
import Numbox from '../Numbox';

const asTextStyle = {
    boxSizing: 'border-box',
    height: 32,
    margin: '0px 10px',
    padding: '0px 10px',
    fontSize: 18,
    fontWeight: 500,
    fontFamily: 'roboto',
    width: '66.6%',
    color: '#414141'
};

const itemStyle = {
    width: 30,
    textAlign: 'right',
    paddingRight: 4
};

const onDragStart = (e, draggedIndex) =>
    e.dataTransfer.setData('index', draggedIndex);

const allowDrop = (e) => e.preventDefault();

const PickListItem = ({
    types,
    index,
    values,
    readOnly = false,
    data,
    setData,
    onOrderChange,
    keyToDisplay,
    ...props
}) => {
    const onDrop = (e) => {
        if (readOnly || typeof onOrderChange !== 'function') return;
        const draggedIndex = e.dataTransfer.getData('index');
        onOrderChange(index, draggedIndex);
    };

    const onChange = (e, k) => {
        const mutar = [...data];
        mutar[index].values[k] = e.target.value;
        setData(mutar);
    };

    const inputField = (k, v) => {
        const value = valueToDisplay(v);
        switch (types[k]) {
            case 'number':
                return (
                    <Numbox
                        key={k}
                        id={`pick-list-numbox-${k}`}
                        style={asTextStyle}
                        value={value}
                        onChange={(e) => onChange(e, k)}
                        placeholder='Add value...'
                    />
                );

            default:
                return (
                    <AsText
                        key={k}
                        id={`pick-list-textbox-${k}`}
                        inputStyle={asTextStyle}
                        value={value}
                        onChange={(e) => onChange(e, k)}
                        placeholder='Add value...'
                    />
                );
        }
    };

    const valueToDisplay = (v) => {
        switch (typeof v) {
            case 'object':
            case 'array':
                return v[keyToDisplay];

            default:
                return v;
        }
    }

    return (
        <li {...props}>
            <Flex
                id='pick-list-item'
                centreVertical
                draggable={!readOnly}
                style={{ height: 40, cursor: readOnly ? 'default' : 'move' }}
                onDragStart={(e) => onDragStart(e, index)}
                onDrop={onDrop}
                onDragOver={allowDrop}
            >
                <div id='pick-list-index' style={itemStyle}>{`${
                    index + 1
                }.`}</div>
                <AutoFlex
                    id='pick-list-content'
                    style={{
                        boxSizing: 'border-box',
                        height: '100%',
                        alignItems: 'center',
                        backgroundColor:
                            (index + 1) % 2
                                ? 'rgba(216,216,216,0.2)'
                                : 'rgba(255,255,255,0)'
                    }}
                >
                    {values.map((v, k) =>
                        readOnly ? (
                            <div
                                key={k}
                                id={`pick-list-ro-text-${k}`}
                                style={{
                                    margin: '0px 20px',
                                    color: '#919191',
                                    fontFamily: 'roboto',
                                    fontWeight: 500,
                                    fontSize: 18,
                                    boxSizing: 'border-box'
                                }}
                            >
                                {`${valueToDisplay(v)} *`}
                            </div>
                        ) : (
                            inputField(k, v)
                        )
                    )}
                </AutoFlex>
            </Flex>
        </li>
    );
};

export default PickListItem;
